import map from "lodash/map";
import { ContentFormatV4 } from "../v4/content_format";
import { TemplateFormatV4 } from "../v4/template_format";
import { ContentFormatV5 } from "../v5/content_format";
import {
  TemplateColorDefinition,
  TemplateFormatV5,
  TemplateOptionDefinition,
} from "../v5/template_format";

export function upgradeContentToV5(contentFormat: ContentFormatV4): ContentFormatV5 {
  return {
    ...contentFormat,
    definition_version: 5,

    pages: map(contentFormat.pages, (pageContent) => {
      return {
        ...pageContent,
        background_color: "#ffffff",

        editable_texts: map(pageContent.editable_texts, (textContent) => {
          return {
            ...textContent,

            font_color: "#000000",
          };
        }),

        forced_texts: [],
      };
    }),
  };
}

export function upgradeTemplateToV5(templateFormat: TemplateFormatV4): TemplateFormatV5 {
  const colorDefinitions: TemplateColorDefinition[] = [];
  const optionDefinitions: TemplateOptionDefinition[] = templateFormat.option_definitions.map(
    (optionDefinition) => {
      return {
        key: optionDefinition.key,
        only_global: true,
        option_choices: optionDefinition.option_values.map((value) => {
          return { value };
        }),
        option_tag: optionDefinition.option_tag,
        type: optionDefinition.type,
      };
    }
  );
  const pageDefinitions = map(templateFormat.page_definitions, (pageDefinition) => {
    const textElements = pageDefinition.elements.filter(
      (element) => element.type === "editable-text" || element.type === "forced-text"
    );
    colorDefinitions.push({
      font_colors: textElements.map((textElement) => {
        const textColor =
          textElement.type === "editable-text" || textElement.type === "forced-text"
            ? textElement.color
            : "#000000";
        return { key: textElement.key, value: textColor };
      }),
      key: `color_${pageDefinition.key}`,
      value: pageDefinition.background_color,
    });

    return {
      ...pageDefinition,
      background_color_keys: [`color_${pageDefinition.key}`],
      conditions: [],

      elements: pageDefinition.elements.map((element) => {
        if (element.type === "editable-text" || element.type === "forced-text") {
          return { ...element, font_color_key: element.key };
        }
        return { ...element, conditions: [] };
      }),

      presentations: pageDefinition.presentations.map((presentation) => {
        return {
          conditions: presentation.condition
            ? [
                {
                  option_definition_key: presentation.condition.option_definition_key,
                  type: "customization",
                  value: presentation.condition.value,
                },
              ]
            : [],
          presentation_definition_key: presentation.presentation_definition_key,
        };
      }),
    };
  });

  return {
    ...templateFormat,
    color_definitions: colorDefinitions,
    definition_version: 5,
    option_definitions: optionDefinitions,
    page_definitions: pageDefinitions,
    presentation_definitions: map(
      templateFormat.presentation_definitions,
      (presentationDefinition) => {
        return presentationDefinition;
      }
    ),
  };
}
